import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

// export lazy route
const Home = lazy(() => import("./home"));

const Home_ROUTES: RouteObject[] = [
  {
    path: "/public/home",
    element: React.createElement(Home),
  },
];

export default Home_ROUTES;
